import api from '@/api/rpa'

const state = {
  contentStatus: { activeNames: ['1', '2', '3', '4'] }
}

const actions = {
  getQrUrl (context, params) {
    return api.getQrUrl(params)
  },
  getTaskList (context, params) {
    return api.getTaskList(params)
  },
  getTaskById (context, taskQuery) {
    return api.getTaskById(taskQuery)
  },
  saveTask (context, task) {
    return api.saveTask(task)
  },
  updateTask (context, task) {
    return api.updateTask(task)
  },
  getTaskAction (context, params) {
    return api.getTaskAction(params)
  },
  updateTaskAction (context, params) {
    return api.updateTaskAction(params)
  },
  getTaskScreenshot (context, params) {
    return api.getTaskScreenshot(params)
  },
  getTaskControl (context, params) {
    return api.getTaskControl(params)
  },
  getDownloadResumeReportData (context, params) {
    return api.getDownloadResumeReportData(params)
  },
  getPostingJobReportData (context, params) {
    return api.getPostingJobReportData(params)
  },
  getResumeDownloadData (context, params) {
    return api.getResumeDownloadData(params)
  },
  getMonitorImage (context, url) {
    return api.getMonitorImage(url)
  },
  changeContentStatus ({ commit }, params) {
    commit('CHANGE_CONTENT_STATUS', params)
  },
  getEmailResumeList (context, params) {
    return api.getEmailResumeList(params)
  },
  getEmailResumeReportData (context, params) {
    return api.getEmailResumeReportData(params)
  },
  getCompanyTaskIp (context, { companyId, params }) {
    return api.getCompanyTaskIp(companyId, params)
  }
}

const mutations = {
  CHANGE_CONTENT_STATUS (state, params) {
    state.contentStatus[params.name] = params.value
  }
}

const getters = {
  contentStatus (state) {
    return state.contentStatus
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
